import React from 'react';
import { ViewDefWizardProps } from './ViewDefWizardProps';
export const viewDefWizardContext = React.createContext<React.ComponentType<ViewDefWizardProps>>(null);
